import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';

import ValidationErrors from './ValidationErrors';

const CheckoutForm = ({ productCode, productCodeType }) => {
    const [firstName, setFirstName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

    const stripe = useStripe();
    const elements = useElements();

    const onSubmit = async (event) => {
        event.preventDefault();
        const errorList = [];

        setLoading(true);

        if (firstName == '') {
            errorList.push('firstName');
        }

        if (surname == ''){
            errorList.push('surname');
        }

        if (email == '') {
            errorList.push('email');
        }

        if (errorList.length === 0) {
            if (!stripe || !elements) {
                setLoading(false);
                return;
            }

            const cardElement = elements.getElement(CardElement);

            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement
            });

            if (error) {
                errorList.push(error.message);
            } else {
                try {
                    const response = await axios.post('/checkout/initialise', {
                        productCode: productCode,
                        productCodeType: productCodeType,
                        firstName,
                        surname,
                        email
                    });

                    const { error, paymentIntent } = await stripe.confirmCardPayment(
                        response.data.clientSecret, {
                            payment_method: paymentMethod.id
                        }
                    );

                    if (error) {
                        errorList.push('Unable to complete payment.');
                    } else {
                        try {
                            const response = await axios.post('/checkout/complete', {
                                id: paymentIntent.id
                            });

                            window.location.href = '/checkout/confirmation';
                        } catch (error) {
                            errorList.push('Could not complete order. Do not re-attempt playment as your card may have been charged. Please contact customer services.');
                            setErrors(errorList);
                            return false;
                        }
                    }
                } catch (error) {
                    errorList.push('Could not initialise payment.');
                }
            }
        }

        setErrors(errorList);
        setLoading(false);
    }

    const firstNameClass = errors.includes('firstName') ? 'error' : null;
    const surnameClass = errors.includes('surname') ? 'error' : null;
    const emailClass = errors.includes('email') ? 'error' : null;

    const buttonText = loading ? 'Please wait...' : 'Complete purchase';

    return (
        <form method="post" className="wide vertical" onSubmit={onSubmit}>
            <ValidationErrors errors={errors} />

            <label for="firstName">First name</label>
            <input
                type="text"
                name="firstName"
                id="firstName"
                value={firstName}
                onChange={event => {
                    setFirstName(event.target.value);
                    setErrors(errors.filter(e => e !== 'firstName'));
                }}
                className={firstNameClass} />

            <label for="surname">Surname</label>
            <input
                type="text"
                name="surname"
                id="surname"
                value={surname}
                onChange={event => {
                    setSurname(event.target.value);
                    setErrors(errors.filter(e => e !== 'surname'));
                }}
                className={surnameClass} />

            <label for="email">Email address</label>
            <input
                type="email"
                name="email"
                id="email"
                value={email}
                onChange={event => {
                    setEmail(event.target.value);
                    setErrors(errors.filter(e => e !== 'email'));
                }}
                className={emailClass} />

            <div className="label">Payment card details</div>
            <CardElement onChange={() => { setErrors([]); }} />

            <button disabled={loading}>{buttonText}</button>
        </form>
    );
}

export default CheckoutForm;
